module.exports = __webpack_public_path__ + "img/base.80ff3486.png";